import './layout.css'
import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useUser } from './context/UserContext'
import { useFormValidation } from './context/FormValidationContext'
import usePageNavigation from './hooks/usePageNavigation'
import PageGuard from './components/pageGuard/pageGuard'
import NavButton from './components/nav-btn/nav-button'

import GettingStarted from './components/progressBar/gettingStarted.jsx'

import MainFocus from './pages/1_MainFocus/mainFocus'
import Gender from './pages/2_Gender/gender'
import Age from './pages/3_Age/age'
import Height from './pages/4_Height/height'
import Weight from './pages/5_CurrentWeight/weight'
import NotAlone from './pages/6_NotAlone/not_alone'
import Name from './pages/7_Name/name'
import BodyType from './pages/8_BodyType/bodyType'
import Tricky from './pages/9_Tricky/tricky'
import BodyFat from './pages/10_BodyFat/bodyFat'
import TargetWeight from './pages/11_TargetWeight/targetWeight'
import BestDescription from './pages/13_BestDescription/bestDescription'
import Consistency from './pages/14_Consistency/consistency'
import Praise from './pages/14_Praise/praise'
import DifficultAreas from './pages/15_DifficultAreas/difficultAreas'
import FocusBuilding from './pages/16_FocusBuilding/focusBuilding'
import Testimonial from './pages/17_Testimonial/testimonial'
import GymExperience from './pages/18_GymExperience/gymExperience'
import Email from './pages/19_Email/email'
import YourProgress from './pages/19_YourProgress/yourProgress'
import Trying from './pages/20_Trying/trying'
import MainReason from './pages/21_MainReason/mainReason'
import BookACall from './pages/21_BookACall/bookACall'

const MainLayout = () => {
  const { page, next, prev } = usePageNavigation()
  const { setUserData, userData } = useUser()
  const { setPageValid, validationStatus, resetValidationStatus } = useFormValidation()
  const { index } = useParams()
  const navigate = useNavigate()

  const [showProgress, setShowProgress] = useState(false)

  // Show progress animation on page 19
  useEffect(() => {
    if (page === 18) {
      setShowProgress(true)
      const timer = setTimeout(() => setShowProgress(false), 2000)
      return () => clearTimeout(timer)
    }
  }, [page])

  // Auto-skip logic for specific diet pages
  useEffect(() => {
    if (page === 26 && userData?.diet !== undefined && userData.diet !== 4 && userData.diet !== 5) {
      setPageValid(26, true)
      userData.lastVisitedPage === 25 ? next() : navigate('/page/25')
    }
  }, [userData, page])

  // Page mapping (Removed page 12)
  const pageComponents = {
    1: <MainFocus />,
    2: <Gender />,
    3: <Age />,
    4: <Height />,
    5: <Weight />,
    6: <NotAlone />,
    7: <Name />,
    8: <BodyType />,
    9: <Tricky />,
    10: <BodyFat />,
    11: <TargetWeight />,
    12: <BestDescription />,
    13: <Consistency />,
    14: <DifficultAreas />,
    15: <FocusBuilding />,
    16: <Testimonial />,
    17: <GymExperience />,
    18: <Email />,
    19: <Trying />,
    20: <MainReason />,
  }

  const screen = pageComponents[page] || <h1>Not Found</h1>

  const goNext = () => {
    const currentPage = parseInt(page)
    if (!validationStatus[currentPage]) return

    setUserData(prev => ({ ...prev, lastVisitedPage: page }))
    sessionStorage.setItem('lastVisitedPage', page)
    next()
  }

  const goPrev = () => {
    setUserData(prev => ({ ...prev, lastVisitedPage: page }))
    sessionStorage.setItem('lastVisitedPage', page)
    prev()
  }

  // Redirect if previous pages aren’t validated
  useEffect(() => {
    if (!validationStatus || Object.keys(validationStatus).length === 0) return
    const currentPage = parseInt(index)
    for (let i = 1; i < currentPage; i++) {
      if (!validationStatus[i]) {
        navigate(`/page/${i}`)
        return
      }
    }
  }, [index, validationStatus, navigate])

  const handleClear = () => {
    localStorage.removeItem('userData')
    resetValidationStatus()
    window.location.reload()
  }

  useEffect(() => {
    localStorage.setItem('validationStatus', JSON.stringify(validationStatus))
  }, [validationStatus])

  const shouldShowBlueHeader =
    page === 6 ||
    page === 9 ||
    (page === 13 &&
      userData.bestDescription !==
        'Good habits, but inconsistent. I try to stay healthy, but I struggle with routine') ||
    page === 16 ||
    page === 20

      console.log('userData', userData)
      console.log('Form Valid', validationStatus)


  return (
    <PageGuard pageNumber={page}>
      <div className='container'>
        <div
          className='header'
          style={{
            backgroundColor: shouldShowBlueHeader ? '#ADD8E6' : '#FFF',
          }}
        >
          {page <= 19 && 'Getting Started'}
          {page <= 19 && <GettingStarted />}
        </div>

        {/* Special page overrides */}
        {page === 6 ? (
          <NotAlone />
        ) : page === 9 ? (
          <Tricky />
        ) : page === 13 &&
          userData.bestDescription !==
            'Good habits, but inconsistent. I try to stay healthy, but I struggle with routine' ? (
          <Praise />
        ) : page === 16 ? (
          <Testimonial />
        ) : page === 18 && showProgress && userData.lastVisitedPage === 18 ? (
          <YourProgress />
        ) : page === 19 ? (
          <Trying />
        ) : page === 20 ? (
          <BookACall />
        ) : (
          <div className='content-wrapper'>
            <div className='card'>{screen}</div>
            <div className='navBtnHolder'>
              {page !== 1 && <NavButton text='Previous' nav={goPrev} />}
              {page < 19 ? (
                <NavButton text='Next' nav={goNext} />
              ) : (
                <button className='result-button' onClick={() => navigate('/results')}>
                  See My Results
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </PageGuard>
  )
}

export default MainLayout
